import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SEO_DATA = {
  "/": {
    title: "Excell-Tutorat | Livres de mathématiques SN4 et CST4 - Tutorat au Québec",
    description: "Excell-Tutorat : livres de mathématiques SN4 et CST4 et physique mécanique au Québec. Tutorat, aide aux devoirs, exercices corrigés. Préparation aux examens du ministère et du cégep.",
    canonical: "https://excelltutorat.com/"
  },
  "/sn4": {
    title: "Livre Mathématiques SN4 | Aide aux devoirs secondaire 4 Sciences Naturelles Québec",
    description: "Livre de mathématiques SN4 pour le secondaire 4 au Québec. 120+ pages, 300+ exercices corrigés, 3 examens blancs ministériels. Aide aux devoirs et préparation examens. 26,99$ CAD.",
    canonical: "https://excelltutorat.com/sn4"
  },
  "/cst4": {
    title: "Livre Mathématiques CST4 | Aide aux devoirs secondaire 4 Culture Société Technique Québec",
    description: "Livre de mathématiques CST4 pour le secondaire 4 au Québec. Tout le programme, exercices corrigés avec solutions détaillées. Aide aux devoirs et préparation examens. 24,99$ CAD.",
    canonical: "https://excelltutorat.com/cst4"
  },
  "/mecanique": {
    title: "Mécanique en action | Livre physique 203-SN1-Re - Exercices résolus cégep Québec",
    description: "Livre physique mécanique 203-SN1-Re pour le cégep au Québec. 200+ pages, 200+ exercices résolus. Cinématique, dynamique, lois de Newton, travail et énergie. 29,99$ CAD.",
    canonical: "https://excelltutorat.com/mecanique"
  },
  "/gratuit": {
    title: "Aide-mémoire mathématiques et physique gratuit | Préparation examens Québec",
    description: "Aide-mémoire gratuits mathématiques SN4, CST4 et physique mécanique. Formules essentielles pour la préparation aux examens au Québec.",
    canonical: "https://excelltutorat.com/gratuit"
  },
  "/contact": {
    title: "Contactez Excell-Tutorat | Tutorat de mathématiques et physique au Québec",
    description: "Contactez Excell-Tutorat pour du tutorat de mathématiques et physique, aide aux devoirs au Québec.",
    canonical: "https://excelltutorat.com/contact"
  }
};

const useSEO = () => {
  const location = useLocation();

  useEffect(() => {
    const data = SEO_DATA[location.pathname] || SEO_DATA["/"];
    document.title = data.title;
    const updates = [
      { selector: 'meta[name="description"]', attr: "content", value: data.description },
      { selector: 'meta[property="og:title"]', attr: "content", value: data.title },
      { selector: 'meta[property="og:description"]', attr: "content", value: data.description },
      { selector: 'meta[property="og:url"]', attr: "content", value: data.canonical },
      { selector: 'meta[name="twitter:title"]', attr: "content", value: data.title },
      { selector: 'meta[name="twitter:description"]', attr: "content", value: data.description },
    ];
    updates.forEach(({ selector, attr, value }) => {
      const el = document.querySelector(selector);
      if (el) el.setAttribute(attr, value);
    });
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', data.canonical);
    window.scrollTo(0, 0);
  }, [location.pathname]);
};

export default useSEO;
